<!--
Based on https://github.com/Code-Pop/real-world-vue/blob/BaseInput-finish/src/components/BaseInput.vue
-->
<template>
    <div
        class="form-group"
        :data-testid="`formGroup-${id}`"
    >
        <label
            v-if="label"
            class="d-flex esinput__label"
            :class="{
                'esinput__label--bold': boldLabel,
            }"
            :for="id"
            :data-testid="`inputLabel-${id}`"
        >
            {{ label }}
        </label>

        <!-- HACK: Using .justify-content-center to center .invalid-tooltip. Is there a better way? -->
        <div class="input-group-lg position-relative d-flex justify-content-center align-items-center">
            <div
                v-if="prependText"
                class="input-group-prepend"
                :data-testid="`prependText-${id}`"
            >
                <span class="input-group-text">{{ prependText }}</span>
            </div>

            <!-- TODO: Listen to `$listeners` to let parent listen to events from <input>
            https://github.com/Code-Pop/real-world-vue/blob/vuelidateP2-finish/src/components/BaseInput.vue
            https://vuejs.org/v2/guide/components-custom-events.html#Binding-Native-Events-to-Components
            -->
            <input
                :id="id"
                :name="name ? name : id"
                :class="[
                    inputClass,
                    plaintext ? 'form-control-plaintext' : 'form-control',
                    invalidClass(validator)
                ]"
                :disabled="plaintext"
                :value="value"
                v-bind="$attrs"
                @input="updateValue"
                @blur="$emit('blur', $event)"
                @change="validator.$touch()"
                @keyup="$emit('keyup', $event)"
            >

            <div
                v-if="appendText"
                class="input-group-append"
                :data-testid="`appendText-${id}`"
            >
                <span class="input-group-text">{{ appendText }}</span>
            </div>

            <slot name="afterInput" />

            <!--
                NOTE: There are some known issues with `.invalid-feedback` (and maybe `-tooltip`) and `.input-group`.
                In 4.5+, the recommendation is to make them siblings. However, that doesn't seem to work in 4.3.
                https://getbootstrap.com/docs/4.5/components/forms/#supported-elements
                https://github.com/twbs/bootstrap/issues/23454
            -->
            <div
                v-if="$slots.validationText"
                class="invalid-tooltip"
            >
                <slot name="validationText" />
            </div>
        </div>

        <!-- TODO: <slot />, e.g. for "Edit" link in welcome.vue, or help text? -->
    </div>
</template>

<script>
import { validationMixin } from '@/utils/mixins';

export default {
    mixins: [validationMixin],
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: false,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        value: {
            type: [String, Number],
            default: '',
        },
        validator: {
            type: Object,
            required: false,
            default: () => {},
        },
        inputClass: {
            type: [String, Object],
            default: '',
        },
        prependText: {
            type: String,
            default: '',
        },
        appendText: {
            type: String,
            default: '',
        },
        plaintext: {
            type: Boolean,
            default: false,
        },
        boldLabel: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        updateValue(event) {
            this.$emit('input', event.target.value);
        },
    },
};
</script>

<style lang="scss" scoped>
.esinput__label--bold {
    font-weight: 600;
}

input[type=password]::-ms-reveal, input[type=password]::-ms-clear {
    display: none !important;
}
</style>
